module.exports = __webpack_public_path__ + "static/media/banner.b1743ac4.png";